import api from '@/services/Api';
import { Manufacturer } from '@/models/referentiel/manufacturer/Manufacturer'
import { List } from '@/models/common/List'

class ManufacturerService {
  async getNetworkAndStoreManufacturerList(storeId) {
    const response = await api.get('/distributor/manufacturer/network-and-store/all/' + storeId)
    return response.data
  }

  async getManufacturerListByStoreList(storeIdList) {
    const response = await api.get('/distributor/manufacturer/all-by-store-list', {
      params: { storeIdList: storeIdList }
    })
    return response.data
  }

  async getManufacturerList() {
    const response = await api.get('/distributor/manufacturer/all')

    const manufacturerList = [];
    for (let manufacturer of response.data.item_list) {
      manufacturerList.push(new Manufacturer(
        manufacturer.technical_id,
        manufacturer.boomerang_id,
        manufacturer.name,
        manufacturer.boomerang_full_support,
        manufacturer.category_count,
        manufacturer.product_count,
      ))
    }

    return new List(
      response.data.count,
      manufacturerList
    )
  }

  async getManufacturerByBoomerangId(boomerangId) {
    const response =
      await api.get('/distributor/manufacturer/by-boomerang-id/' + boomerangId)

    return new Manufacturer(
      response.data.technical_id,
      response.data.boomerang_id,
      response.data.name,
      response.data.boomerang_full_support,
      response.data.category_count,
      response.data.product_count,
    )
  }

  async getManufacturerListInMilwaukeeWhitelist() {
    const response = await api.post(
      '/distributor/manufacturer/get-manufacturers-in-milwaukee-whitelist'
    )
    return response.data
  }
}

export default new ManufacturerService()
